var React = require('react');

function LineLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.3536 4.35355C33.5488 4.15829 33.5488 3.84171 33.3536 3.64645L30.1716 0.464466C29.9763 0.269204 29.6597 0.269204 29.4645 0.464466C29.2692 0.659728 29.2692 0.976311 29.4645 1.17157L32.2929 4L29.4645 6.82843C29.2692 7.02369 29.2692 7.34027 29.4645 7.53553C29.6597 7.7308 29.9763 7.7308 30.1716 7.53553L33.3536 4.35355ZM0 4.5H33V3.5H0V4.5Z","fill":"white"}));
}

LineLight.defaultProps = {"width":"34","height":"8","fill":"none"};

module.exports = LineLight;

LineLight.default = LineLight;
